import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { OperacionLCTC, schemaOperacionLCTC } from '../types/types'
import { BaseResponse } from 'src/types'
import {
    OperacionLCTCInsert,
    schemaOperacionLCTCInsert,
    OperacionLCTCCuentaVista,
    schemaOperacionLCTCCuentaVista,
    OperacionLCTCCuentaLimiteUpdate,
    schemaOperacionLCTCCuentaLimiteUpdate,
    schemaOperacionLCTCCuentaHistoriaDTO,
    OperacionLCTCCuentaHistoriaDTO,
    OperacionLCTCLimitesAprobadosPais,
    schemaOperacionLCTCLimitesAprobadosPais,
    schemaListaOperacionLCTCLimitesAprobadosPais
} from '../types/dto'
import { z } from 'zod'
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme";
import { SistemaTipo } from "../../../../../types/enum/enum"
import { FormFiltros } from '../../../../limites/FiltrosBusqueda'

export const getEndpoint = (url = '') => `operaciones/lctc${url}`

export const HttpLCTC = {
    get: (idOperacion: number): Promise<OperacionLCTC> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionLCTC.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionLCTCInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCTCInsert.safeParse(operacion)
        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getCuentas: (idOperacion: number): Promise<OperacionLCTCCuentaVista[]> => {
        const url = getEndpoint(`/${idOperacion}/cuentas`);
        const schemaResponse = z.array(schemaOperacionLCTCCuentaVista);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getCuentas:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getCuentas:', error);

                return Promise.reject('Error de red.');
            });
    },

    getCuentasHistoria: (idOperacion: number): Promise<OperacionLCTCCuentaHistoriaDTO[]> => {
        const url = getEndpoint(`/${idOperacion}/cuentas/historia`);
        const schemaResponse = z.array(schemaOperacionLCTCCuentaHistoriaDTO);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getCuentasHistoria:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getCuentas:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateLimite: (idOperacion: number, idLimite: number, limiteUpdate: OperacionLCTCCuentaLimiteUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCTCCuentaLimiteUpdate.safeParse(limiteUpdate);
        if (!parsed.success) {
            console.error('Error de validación de entrada en updateLimite:', parsed.error.issues);

            return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/cuentas/limites/${idLimite}`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateLimite:', error);

                return Promise.reject('Error de red.');
            });
    },

    getLimitesAprobados: (filtros: FormFiltros): Promise<OperacionLCTCLimitesAprobadosPais[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`/limites`), { ...filtros })
            .then(response => {
                const parsed = schemaListaOperacionLCTCLimitesAprobadosPais.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.LCTC),

} as const
